import { AppState, NamedTagGroup } from "./AppState";

export class AppStateJsonSerializer {
	static serialize(appState: AppState): string | null {
		try {
			return JSON.stringify(appState.groups);
		} catch (e) {
			console.error("Error: Could not serialize application state!");
		}

		return null;
	}

	static deserialize(representation: string): AppState | null {
		try {
			const groups = JSON.parse(representation) as NamedTagGroup[];
			if (groups) {
				return new AppState(groups);
			}
		} catch (e) {
			console.error("Error: Could not deserialize application state!");
		}

		return null;
	}
}
